// src/stone/illustrations/HandsUsingAppIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var HandsUsingAppIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64",
    ...props,
    children: [
      /* @__PURE__ */ jsx("rect", { width: 64, height: 64, fill: "#E8FEF3", rx: 4 }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E09661",
          d: "M48.198 48.032c4.162-2.982 8.41-15.441 6.941-20.787-.377-1.367-2.586-1.947-4.294.652a70 70 0 0 0-2.179 3.542c-1.955-8.64-3.353-10.116-4.923-10.271-1.044-.108-3.973.646-2.489 5.659l.11.35c0 .007.007.018.009.024s-.01-.005-.012-.005a9 9 0 0 0-.817-.313c-3.841-1.29-5.017 1.291-4.287 3.22.272.716.865 1.43 1.48 2.026q.856.825 1.826 1.51-.14.018-.277.046c-3.509.661-6.102 3.38-6.39 6.79-.384 4.51 2.183 8.078 5.797 9.164 3.543 1.07 6.692.41 9.505-1.607"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m42.795 28.555.092-.224-.133-.082q.02.147.04.306M40.38 33.655l.138.451 2.271-5.535a7 7 0 0 0-.631-.376l-3.073 3.948q.591.803 1.296 1.511"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M39.292 38.554 44.6 41.04a.805.805 0 0 0 1.07-.388l9.724-20.775a.805.805 0 0 0-.388-1.07l-5.309-2.484a.805.805 0 0 0-1.07.387l-9.723 20.775a.805.805 0 0 0 .388 1.07"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m39.295 38.551 5.307 2.485a.804.804 0 0 0 1.071-.39l6.568-14.032-8.788 1.153-4.546 9.714a.805.805 0 0 0 .388 1.07"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "m28.776 33.632 12.999 6.083a.94.94 0 0 0 1.25-.453l9.608-20.528a.94.94 0 0 0-.453-1.251l-13-6.084a.94.94 0 0 0-1.25.453L28.321 32.38a.94.94 0 0 0 .454 1.252"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          d: "m30.884 31.581 11.389 5.33 8.074-17.251-11.39-5.33z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m31.94 32.076 10.333 4.836 8.074-17.252-10.333-4.836z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M45.194 16.353a.51.51 0 1 0 0-1.019.51.51 0 0 0 0 1.019"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E09661",
          d: "M46.473 46.171c.901-1.628 4.743-6.358 2.146-10.12-1.31-1.895-2.92-3.294-4.128-3.98-.666-.324-1.97-.23-2.652.849-.673 1.132-.555 3.898.98 5.692-2.55-.582-5.334 1.062-6.26 2.892"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M46.473 46.172a.115.115 0 0 1-.081-.194c.58-.61 2.341-3.15 2.884-5.928a5.63 5.63 0 0 0-.964-4.374 12 12 0 0 0-.835-1.049.116.116 0 0 1 .17-.157q.456.511.851 1.07a5.86 5.86 0 0 1 1.006 4.554c-.553 2.831-2.352 5.42-2.944 6.043a.12.12 0 0 1-.087.035"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E09661",
          d: "M21.52 28.184c6.947-2.585 13.853-2.755 16.858-1.716 1.057.366 2.21 1.335 1.827 2.535-.417 1.306-1.585 1.793-2.517 2.087-2.361.744-5.945 1.028-9.319 2.28"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E09661",
          d: "M25.798 40.722c-2.228 1.496-7.237 4.095-13.185 1.023-2.5-1.292-7.827-5.898-4.609-13.31 1.23-2.836 4.57-6.03 8.804-6.774 2.059-.364 4.155-.11 5.464 1.8 1.556-.27 4.947.634 5.915 2.996.285.824.554 1.8.866 2.612.46 1.203.827 2.468.799 3.758a10.2 10.2 0 0 1-.492 2.856c-.656 2.055-1.925 3.938-3.562 5.04"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M18.776 24.296a.116.116 0 0 1-.04-.224 12.8 12.8 0 0 1 4.593-.747.115.115 0 0 1 0 .23 12.6 12.6 0 0 0-4.51.735.1.1 0 0 1-.043.006M22.429 27.92a.116.116 0 0 1-.1-.173.12.12 0 0 1 .06-.05c1.46-.523 4.226-1.116 5.737-1.423a.115.115 0 1 1 .046.226c-1.51.307-4.257.896-5.705 1.413a.1.1 0 0 1-.038.007M29.36 35.684c-.584-.944-1.46-1.445-2.535-1.634a25 25 0 0 1 3.03-1.171 9.9 9.9 0 0 1-.495 2.805"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M29.177 36.036a.12.12 0 0 1-.1-.058c-.762-1.35-2.249-1.742-2.264-1.746a.12.12 0 0 1-.077-.05.115.115 0 0 1 .005-.134.115.115 0 0 1 .128-.038c.065.016 1.597.415 2.409 1.854a.117.117 0 0 1-.044.157.1.1 0 0 1-.057.015M36.558 41.62a.116.116 0 0 1-.103-.166c.572-1.128 1.81-2.158 3.23-2.69a.115.115 0 0 1 .134.157.12.12 0 0 1-.057.06c-1.37.511-2.559 1.5-3.105 2.577a.12.12 0 0 1-.099.062"
        }
      )
    ]
  }
);
var HandsUsingAppIllustration_default = HandsUsingAppIllustration;

export {
  HandsUsingAppIllustration_default
};
